import React from "react";
import "./Destination.css";
import DestinationData from "./DestinationData";
import travel1 from "../assets/travel7.jpg";
import travel2 from "../assets/travel8.jpg";
import travel3 from "../assets/travel9.jpg";
import travel4 from "../assets/travel10.jpg";
import travel5 from "../assets/travel11.jpg";
import travel6 from "../assets/travel12.jpg";

const Destination = () => {
  return (
    <div className="destination">
      <h1>Popular Destination</h1>
      <p>Tours give you the opportunity to see a lot, within a time frame.</p>

      <DestinationData
        className="first-des"
        heading="Hemis, Ladakh, India"
        text="Embark on a mesmerizing journey to Ladakh, India, where the stark beauty of the Himalayas meets vibrant cultural traditions. Explore ancient monasteries like Thiksey and Hemis, perched atop rugged hills. Marvel at the pristine Pangong Lake, its azure waters reflecting snow-capped peaks. Engage in thrilling adventures, from high-altitude trekking to river rafting on the Indus. Ladakh's unique blend of landscapes and spirituality, coupled with warm Ladakhi hospitality, creates an immersive experience, making it a destination that lingers in the heart long after the journey ends."
        img1={travel1}
        img2={travel2}
      />

      <DestinationData 
        className="first-des-reverse"
        heading="Beach destinations Goa, India"
        text="Goa, India, is renowned for its sun-kissed shores and diverse beach experiences. Calangute Beach offers lively vibes with water sports and vibrant markets, while Palolem Beach entices with serene landscapes and beachfront huts. Anjuna Beach is famous for its bohemian spirit and vibrant nightlife, while the quieter Agonda Beach provides a tranquil escape. With each beach boasting its unique charm, Goa caters to every traveler's preference, ensuring a perfect blend of relaxation, adventure, and the unmistakable Goan spirit."
        img1={travel3}
        img2={travel4}
      />

      <DestinationData
        className="first-des"
        heading="Rishikesh, Uttarakhand, India"
        text="Nestled in the lap of Uttarakhand, India, Rishikesh is a spiritual haven and adventure seeker's paradise. Set along the Ganges River, it's renowned for its iconic suspension bridge, Laxman Jhula, and spiritual significance as a yoga capital. The town offers a tranquil escape with ashrams and temples dotting the landscape. Adventure enthusiasts flock for white-water rafting and trekking in the nearby Himalayas. Rishikesh's serene ambiance, spiritual energy, and scenic beauty make it a compelling destination for those seeking both introspection and exhilaration."
        img1={travel5}
        img2={travel6}
      />
    </div>
  );
};

export default Destination;
